module.exports = __webpack_public_path__ + "media/images/slides/girl_reading-a3f2336aa66b3a01c6303872f08ede74.jpg";